import type { HTMLAttributes } from "react";

import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TMainProps = {
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TMainDefaultProps = DefinedDefaults<
  TMainProps,
  "data-component" | "id"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const MAIN_DEFAULTS = {
  "data-component": "Main",
  id: "main-content",
} satisfies TMainDefaultProps;
